import { useState } from 'react';

/**
 * @param initialState
 * @param onSubmit
 */
export const useForm = (
  /* eslint-disable default-param-last */
  initialState = {},
  onSubmit,
) => {
  const [formData, setFormData] = useState(initialState);

  if (typeof window !== 'undefined') {
    const sessionStorage = window?.sessionStorage;
    window.onbeforeunload = () => {
      sessionStorage.clear();
    };
  }

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    sessionStorage.setItem('vrm', e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return {
    formData,
    handleInputChange,
    handleSubmit,
  };
};
